// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/examples.js with go/sail-next-tailor-docs-publisher

import {BarChartExamples} from './BarChart';
import {ButtonExamples} from './Button';
import {ButtonGroupExamples} from './ButtonGroup';
import {LinkExamples} from './Link';
import {DrawerExamples} from './Drawer';
import {MenuExamples} from './Menu';
import {PopoverExamples} from './Popover';
import {BadgeExamples} from './Badge';
import {CounterExamples} from './Counter';
import {ImgExamples} from './Img';
import {LineChartExamples} from './LineChart';
import {ListExamples} from './List';
import {NoticeExamples} from './Notice';
import {CheckboxExamples} from './checkbox';
import {TextareaExamples} from './textarea';
import {TextFieldExamples} from './textfield';
import {SelectExamples} from './select';
import {RadioExamples} from './radio';
import {SwitchExamples} from './switch';
import {DividerExamples} from './Divider'; // NOTE: These tailor component examples are copied to the external
import {TabsExamples} from './tabs';
// stripe docs for Tailor UI Toolkit via http://go/sail-next-tailor-docs-publisher

export const tailorComponentExamples = {
  BarChart: BarChartExamples,
  Button: ButtonExamples,
  ButtonGroup: ButtonGroupExamples,
  Link: LinkExamples,
  Menu: MenuExamples,
  Badge: BadgeExamples,
  Counter: CounterExamples,
  Img: ImgExamples,
  LineChart: LineChartExamples,
  List: ListExamples,
  Checkbox: CheckboxExamples,
  Notice: NoticeExamples,
  TextArea: TextareaExamples,
  Select: SelectExamples,
  TextField: TextFieldExamples,
  Tabs: TabsExamples,
  Radio: RadioExamples,
  Switch: SwitchExamples,
  Divider: DividerExamples,
};
export const componentToExamples = {
  ...tailorComponentExamples,
  Drawer: DrawerExamples,
  Popover: PopoverExamples,
};
